import styled from 'styled-components';

import { colors, fontSizes, fonts } from 'shared/defaultTheme';

export const UploadDocumentsWrapper = styled.div`
  padding: 0 4px;
  padding-bottom: 0;
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;
    margin-left: -1px;
    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .upload-info-container {
    min-height: auto;
    max-height: 432px;
    overflow: auto;
    margin-left: 12px;
    width: 100%;
  }
  .upload-list {
    width: 75%;
  }
  .button-icon {
    svg {
      fill: ${colors.black} !important;
    }
  }
  .document-success-upload {
    color: ${colors.pastelGreen};
  }
  .document-fail-upload {
    color: ${colors.error};
  }
`;
